import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ConfigurationOptionService } from '../configuration-option.service'
import { NotificationService } from 'src/app/core/notification.service'
import { Actions, ofType } from '@ngrx/effects'
import { configurationOptionActions } from '../configuration-option.actions'
import { ConfigurationOptionKeys } from '../configuration-option'
import { DiscoveryAreaConfigWebOption } from 'src/app/shared/discovery-area.types'
import { ConfigOptionsKeys } from '../../../shared/constants'

@Component({
  selector: 'configuration-option-payments-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionTagFilterTabComponent implements OnInit {
  public configFormValues$: Observable<any>
  public isLoading$: Observable<boolean>
  public isCollapsed = false
  public discoveryAreaConfigHasValue$: Observable<boolean>
  public form: UntypedFormGroup
  public accessRights = AccessRights
  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.configFormValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
    this.discoveryAreaConfigHasValue$ = this.store
      .select(
        configurationOptionSelectors.selectByKey,
        ConfigOptionsKeys.DISCOVERY_AREA_CONFIG
      )
      .pipe(
        map((webOption) => {
          if (!webOption?.value) {
            return false
          }
          const discoveryAreaConfigs: DiscoveryAreaConfigWebOption[] =
            webOption?.value ? JSON.parse(webOption.value) : null
          return !!discoveryAreaConfigs?.length
        })
      )
  }

  public onSubmit(formValues): void {
    this.configOptionService.updateOrCreateMany(formValues)
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
